import React from 'react';
import { Shield, CheckCircle, Sparkles } from 'lucide-react';
import { SectionHeader } from '../ui/SectionHeader';
import { safetyTips } from '../../data/education/tips';
import { useSafetyTips } from '../../hooks/useEducationContent';

export function SafetyTips() {
  const { data: aiTips, isLoading: tipsLoading } = useSafetyTips();

  const displayTips = aiTips && aiTips.length > 0 ? aiTips : safetyTips;
  const isAIContent = aiTips && aiTips.length > 0;

  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden">
      <div className="relative h-48">
        <img
          src="https://images.unsplash.com/photo-1563013544-824ae1b704d3"
          alt="Security and safety in financial trading"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-green-900/80 to-green-800/60" />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center text-white">
            <Shield className="h-12 w-12 mx-auto mb-2" />
            <h2 className="text-2xl font-bold">Safety Tips</h2>
          </div>
        </div>
      </div>
      <div className="p-6">
        {isAIContent && (
          <div className="mb-4 flex items-center gap-2 text-sm text-emerald-600 bg-emerald-50 px-3 py-2 rounded-lg">
            <Sparkles className="h-4 w-4" />
            <span>AI-generated safety tips updated with latest threats</span>
          </div>
        )}

        {tipsLoading ? (
          <div className="grid gap-4">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className="flex items-start gap-3 p-4 bg-gray-50 rounded-lg animate-pulse">
                <div className="h-5 w-5 bg-gray-200 rounded-full"></div>
                <div className="flex-1">
                  <div className="h-5 bg-gray-200 rounded w-2/3 mb-2"></div>
                  <div className="h-4 bg-gray-200 rounded w-full mb-1"></div>
                  <div className="h-4 bg-gray-200 rounded w-4/5"></div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="grid gap-4">
            {displayTips.map((tip, index) => (
              <div key={index} className="flex items-start gap-3 p-4 bg-gray-50 rounded-lg border-l-4 border-emerald-500">
                <CheckCircle className="h-5 w-5 text-emerald-600 mt-0.5 flex-shrink-0" />
                <div>
                  <h3 className="font-semibold mb-1">{tip.title}</h3>
                  <p className="text-gray-600">{tip.description}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}